// src/services/postServices.js
import api from "./api";

// Public: get all posts
export const getPosts = async () => {
  const { data } = await api.get("/post");
  return data;
};

// Admin: get posts for dashboard table
export const getAdminPosts = async () => {
  const { data } = await api.get("/post/admin/posts", {
    withCredentials: true,
  });
  return data;
};

// Admin: create post (FormData with images)
export const addPost = async (postData) => {
  const { data } = await api.post("/post", postData, {
    withCredentials: true,
  });
  console.log(data);
  return data;
};

// Admin: get single post by ID for editing
export const getPostById = async (postId) => {
  const { data } = await api.get(`/post/id/${postId}`, {
    withCredentials: true,
  });
  return data;
};

// Admin: update post by ID
export const updatePost = async (postId, postData) => {
  const { data } = await api.put(`/post/id/${postId}`, postData, {
    withCredentials: true,
  });
  return data;
};

// Admin: delete post by ID
export const deletePost = async (postId) => {
  const { data } = await api.delete(`/post/id/${postId}`, {
    withCredentials: true,
  });
  return data;
};
